<template>
    <div class="logo-wrapper">
        <img :src="logo" alt="logo" class="logo"/>
    </div>
</template>
<script>
import {mapActions, mapMutations, mapState} from "vuex";
import {accountService} from "@/services/AccountService";
import {markAppReloading} from "@/helpers/appReload";
import {hasPendingOrgTarget, takePendingOrgTarget} from "@/helpers/orgFromUrl";

const ABILITIES_TIMEOUT = 10000;

export default {
    name: "CheckAbilities",
    data() {
        return {
            timeoutId: null,
            isSwitchingOrg: false,
        };
    },
    computed: {
        ...mapState("account", {
            currentUser: "user",
            firstAllowedPage: "firstAllowedPage",
        }),

        logo() {
            return require(`../assets/logo.svg`);
        },
    },
    methods: {
        ...mapActions("account", ["logout"]),
        ...mapMutations("account", ["accountResponse"]),
        navigate() {
            if (this.isSwitchingOrg) return;
            if (!hasPendingOrgTarget()) {
                this.navigateToFirstAllowedPage();
                return;
            }
            if (!this.currentUser) return;
            this.openOrgTarget(takePendingOrgTarget());
        },
        canSwitchToOrg(orgId) {
            if (!this.isAdminUser || String(orgId) === String(this.currentUser.orgId)) return false;
            return (this.currentUser.managedOrganizations || []).some(org => String(org.orgId) === String(orgId));
        },
        openOrgTarget(target) {
            if (!target) {
                this.navigateToFirstAllowedPage();
                return;
            }
            const destination = target.path ? {path: target.path, query: target.query, hash: target.hash} : null;
            if (!this.canSwitchToOrg(target.orgId)) {
                if (destination) this.$router.replace(destination);
                else this.navigateToFirstAllowedPage();
                return;
            }
            this.isSwitchingOrg = true;
            accountService.switchOrg(target.orgId)
                .then((response) => {
                    this.accountResponse(response.data);
                    markAppReloading();
                    window.location.replace(this.$router.resolve(destination || "/").href);
                })
                .catch(() => {
                    this.isSwitchingOrg = false;
                    if (destination) this.$router.replace(destination);
                    else this.navigateToFirstAllowedPage();
                });
        },
        navigateToFirstAllowedPage() {
            if (this.firstAllowedPage) {
                this.$router.push({path: this.firstAllowedPage});
                console.log("Navigating to first allowed page: ", this.firstAllowedPage);
            } else if (this.currentUser && (this.currentUser.type === "ADMIN" || this.currentUser.type === "SUPER_USER")) {
                this.$router.push({path: "/dashboard"});
                console.log("Navigating to dashboard");
            }
        },
    },
    mounted() {
        this.timeoutId = setTimeout(() => {
            console.warn(`CheckAbilities: aucune page autorisee apres ${ABILITIES_TIMEOUT}ms, deconnexion.`);
            this.logout();
        }, ABILITIES_TIMEOUT);

        this.navigate();
    },
    beforeUnmount() {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
            this.timeoutId = null;
        }
    },
    watch: {
        firstAllowedPage() {
            this.navigate();
        },
        currentUser() {
            this.navigate();
        },
    }
};
</script>
<style lang="scss" scoped>
.logo-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
}

.logo {
    width: 50px;
    border-radius: 3px;
    filter: grayscale(0%);
    transform: scale(1);
    animation: animGrayscaleAndScale 1s forwards alternate infinite;
}

@keyframes animGrayscaleAndScale {
    0% {
        filter: grayscale(0%);
        transform: scale(1);
        opacity: 1;
    }
    100% {
        filter: grayscale(100%);
        transform: scale(0.8);
        opacity: 0.4;
    }
}
</style>

